import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to disabling/enabling showing multiple locations tag in the jobsite/pod selector
 * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-10381
 */
@Injectable()
export class NofJobsiteMultipleLocationsFeature implements IFlagFeature {
  name: string = Features.NOF_JOBSITE_MULTIPLE_LOCATIONS;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
